"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

require("../util/GlobalScript.js");

var _context5, _context6;

/*eslint-disable valid-jsdoc*/
"use strict";
/**
* @module util/FilterUtils
* @desc A set of search util functions.
*/

/**
* @alias module:util/FilterUtils.filterFieldStartsWith
* @desc Searches the specified field within item for a starts with match of filter
*    (leading/trailing whitespace ignored).
*
* @param {string} field
*    The field to use in the search.
* @param {string} filter
*    The value to search for.
* @param {object} item
*    The object to search.
*
* @return {boolean}
*    True if filter matches the start of the field within item, false otherwise.
*/


exports.filterFieldStartsWith = function (field, filter, item) {
  filter = (0, _trim.default)(filter).call(filter).toLowerCase();

  if (field) {
    var _context;

    if (!item[field]) {
      return false;
    }

    return (0, _startsWith.default)(_context = item[field].toLowerCase()).call(_context, filter);
  } else {
    for (var key in item) {
      var _context2;

      if (item[key].toString && (0, _startsWith.default)(_context2 = item[key].toString().toLowerCase()).call(_context2, filter)) {
        return true;
      }
    }

    return false;
  }
};
/**
* @alias module:util/FilterUtils.filterFieldContains
* @desc Searches the specified field within item for a contains match of filter
*    (leading/trailing whitespace ignored).
*
* @param {string} field
*    The field to use in the search.
* @param {string} filter
*    The value to search for.
* @param {object} item
*    The object to search.
*
* @return {boolean}
*    True if filter matches some portion of the field within item, false otherwise.
*/


exports.filterFieldContains = function (field, filter, item) {
  filter = (0, _trim.default)(filter).call(filter).toLowerCase();

  if (field) {
    var _context3;

    // .includes not supported by IE
    if (!item[field]) {
      return false;
    }

    return (0, _indexOf.default)(_context3 = item[field].toLowerCase()).call(_context3, filter) !== -1;
  } else {
    for (var key in item) {
      var _context4;

      // .includes not supported by IE
      if (item[key] !== undefined && item[key].toString && (0, _indexOf.default)(_context4 = item[key].toString().toLowerCase()).call(_context4, filter) !== -1) {
        return true;
      }
    }

    return false;
  }
};
/**
 * @alias module:util/FilterUtils.filterStartsWith
 * @desc Searches the specified item for a starts with match of filter in any string-able field
 *    (leading/trailing whitespace ignored).
 *
 * @param {string} filter
 *    The value to search for.
 * @param {object} item
 *    The object to search.
 *
 * @return {boolean}
 *    True if filter matches the start of any string-able field within item, false otherwise.
 */


exports.filterStartsWith = (0, _bind.default)(_context5 = exports.filterFieldStartsWith).call(_context5, null, null);
/**
 * @alias module:util/FilterUtils.filter
 * @desc Searches the specified the specified item for a match of filter in any string-able field
 *    (leading/trailing whitespace ignored).
 *
 * @param {string} filter
 *    The value to search for.
 * @param {object} item
 *    The object to search.
 *
 * @return {boolean}
 *    True if filter matches some portion of any string-able field within item, false otherwise.
 */

exports.filterContains = (0, _bind.default)(_context6 = exports.filterFieldContains).call(_context6, null, null);
/**
 * @alias module:util/FilterUtils.getFilterFunction
 * @desc Returns the appropriate filter function based on the search string's length
 *    (leading/trailing whitespace ignored) and whether a field name to search was given.
 *    Search returns true if the filter string is contained within the string being searched.
 *    If no field name is given to search will return filters that search all string-able properties of an object.
 *
 * @param {object} str
 *    The value to search for.
 * @param {string} fieldName
 *    The field to use in the search.
 *
 * @return {function}
 *    A filter function.
 */

exports.getFilterFunction = function (str, fieldName) {
  var _context7, _context8;

  str = (0, _trim.default)(str).call(str);
  return fieldName ? (0, _bind.default)(_context7 = exports.filterFieldContains).call(_context7, null, fieldName, str) : (0, _bind.default)(_context8 = exports.filterContains).call(_context8, null, str);
};